module.exports = __webpack_public_path__ + "media/images/emblems/Rothenburg_LU-8a6055fa5f8cfdbea8099bb55434bbba.png";